import format from 'civic-champs-shared/utils/format'
import { isEmpty, map } from 'lodash'
import { formatActivityCheckInExportFields } from './utils/activityCheckInValues'

export default function useActivityExportConfig() {
  const filename = 'activities.csv'
  const headers = [
    { label: 'First Name', key: 'user.givenName' },
    { label: 'Last Name', key: 'user.familyName' },
    { label: 'Email', key: 'user.email' },
    { label: 'Phone Number', key: 'user.phoneNumber' },
    { label: 'Opportunity', key: 'opportunity.name' },
    { label: 'Activity', key: 'volunteeringRole.name' },
    { label: 'Check-In Date', key: 'checkInDate' },
    { label: 'Check-In Time', key: 'checkInTime' },
    { label: 'Check-Out Date', key: 'checkOutDate' },
    { label: 'Check-Out Time', key: 'checkOutTime' },
    { label: 'Hours', key: 'hoursVolunteered' },
    { label: 'Reflection', key: 'reflection' },
    { label: 'Rating', key: 'volunteerSatisfaction' },
    { label: 'High-Fives', key: 'rating' },
    { label: 'Notes', key: 'team' },
    { label: 'Address', key: 'location.address.line1' },
    { label: 'City', key: 'location.address.city' },
    { label: 'State', key: 'location.address.state' },
    { label: 'Zip', key: 'location.address.zipCode' },
    { label: 'Groups', key: 'groups' },
    { label: 'Tags', key: 'volunteerTags' },
  ]
  const useFormattedData = data =>
    data.map(o => {
      Object.assign(o, formatActivityCheckInExportFields(o))
      o.hoursVolunteered = format.hours(o.hoursVolunteered, 2)
      if (o.user) {
        o.user.phoneNumber = format.phoneNumber(o.user.phoneNumber)
      }

      if (!isEmpty(o.volunteerTags)) {
        o.volunteerTags = map(o.volunteerTags, 'name').join(', ')
      } else {
        o.volunteerTags = ''
      }

      return o
    })

  return { headers, filename, useFormattedData }
}
